import { createSelector } from '@ngrx/store';
import { calendarState } from '~gc/domains/work/calendar/calendar.state';
import { get } from '../../../shared/utils/func';

export const calendarAreaTitle = createSelector(calendarState, get('title'));
